// Core
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// Pages
import { Login } from 'src/features/login/Login';

export const Public: React.FC = () => {
  const queryParams = new URLSearchParams(location.search);

  return (
    <Switch>
      <Route path={'/login'} exact component={Login} />
      <Route
        path="/sso"
        component={() => {
          window.location.href = `${window.AUTH_SERVICE_URL}?action=driver&redirect=${window.REACT_APP_BASE_URL}?${queryParams}`;
          return null;
        }}
      />
      <Redirect to={'/login'} />
    </Switch>
  );
};
